module.exports = __webpack_public_path__ + "static/img/sta3.19cdc80.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/sta3.png
// module id = 97xu
// module chunks = 1